/**
 * Preise kommen vom Backend als Decimal und damit als String ("49.00") an.
 * Diese Helfer machen daraus vergleichbare Zahlen und deutsche Preistexte.
 */

export function toNumber(value: unknown): number {
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? ''))
  return Number.isFinite(n) ? n : 0
}

/** 49.00 → "49 €", 49.90 → "49,90 €" */
export function formatEuro(value: unknown): string {
  const n = toNumber(value)
  const hasCents = Math.round(n * 100) % 100 !== 0
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(n)
}

/** Wandelt die Settings-Liste des Backends in ein einfaches Objekt um. */
export function settingsToMap(
  data: Array<{ key: string; value: string | null }> = []
): Record<string, string> {
  const map: Record<string, string> = {}
  data.forEach(setting => {
    if (setting?.key) map[setting.key] = setting.value ?? ''
  })
  return map
}
